<template>
	<div 
		class="gb-photoalbum-create" 
		v-bind:style="styleAlbumCliate"
	>
		<Loading v-if="loading" opacity="0.5"/>
		<GBPhotoAlbumDrop 
			@drop="onChangeFile"
		/>
		<GBPhotoAlbumHeader 
			v-bind:backURL="backURL" />
		<div class="d-flex" style="z-index: 103;">
			<GBPhotoAlbumListAlbumHeader 
				v-bind:name="list_albums.name"
				v-bind:begin="list_albums.begin"
				v-bind:end="list_albums.end"
				v-bind:title="list_albums.title"/>
			<div class="gb-header-photo-list" v-bind:style="stylePhotoList">
				<div class="primary gb-header-photo-layout">
					<template v-if="!is_selecting_images">
						<v-layout align-center row fill-height>
							<v-btn flat large color="white" class="pa-0"
								:disabled="this.album.items.length == 0 || hasParent() == false"
								v-on:click="onClickCreateAlbum">作成</v-btn>
							<v-spacer />
							<div class="d-flex">
								<v-select
									ref="select_quality"
									dark
									v-model="selected_quality"
									v-bind:items="item_quality"
									item-color= "white"
									item-text="name"
									item-value="value"
									style="width: 100px; margin-left:8px; margin-right:8px;"
									:disabled="hasParent() == false"
									v-on:input="onInputImageQuality">
								</v-select>
							</div>
							<v-btn 
								color="white"
								flat large 
								class="pa-0"
								:disabled="hasParent() == false"
								v-on:click="onPhotoUpload">写真を登録</v-btn>
							<input id="select_photo" type="file" v-on:change="onChangeFile" style=" display: none;" multiple/>
							<v-btn flat large color="white" class="pa-0" 
								style="min-width:30px"
								:disabled="hasParent() == false"
								v-on:click="onClickStartSelectingImages">選択</v-btn>
						</v-layout>
					</template>
					<template v-else>
						<v-layout align-center row fill-height>
							<v-btn flat dark color="white" @click="onClickCancelSelectingImages">キャンセル</v-btn>
							<v-spacer />
							<h4 class="album-title" style="color: #FFFFFF;">{{ selected_images.length }}枚を選択中</h4>
							<v-spacer />
							<v-btn flat dark color="white" @click="onClickSelectAllImages">すべて選択</v-btn>
						</v-layout>
					</template>
				</div>
			</div>
		</div>
		<div class="d-flex">
			<GBPhotoAlbumSelectList 
				v-bind:items= "listItems"
				v-bind:select_id="photoalbum_id"
				v-on:select-list="selectPhotoAlbum"/>
			<div 
				class="gb-album-content-outer"
				v-bind:style="styleContentOuter">
				<div class="content" v-bind:style="stylePhotoListHeight">
					<div v-if="hasParent()"
						class="gb-photo-create-list" v-bind:style="stylePhotoList">
						<div class="pa-2">
							<v-form ref="form_title" v-on:submit.prevent="onSubmitTitle">
								<v-text-field
									v-model="album.title"
									maxlength="50"
									single-line
									v-bind:rules="[RULES.length_title]"
									v-bind:placeholder="placeholderTitle"
								/>
							</v-form>
							<v-layout align-center row fill-height>
								<h2>写真</h2>
							</v-layout>
							<template v-if="album.items.length > 0">
								<v-layout wrap>
									<div style="position: relative; display: inline-block; padding-right:10px" 
										v-for="item in album.items" 
										:key="item.id">
										<div style="cursor: pointer;"
											v-on:click="onClickImage(item.id)" >
											<v-lazy-image :src="item.thumbnail_uri" style="height: 200px;"/>
										</div>
										<v-btn v-if="is_selecting_images" fab
											color="white"
											v-bind:outline="!isSelectedImage(item.id)"
											@click="onClickToggleSelectImage(item.id)"
											style="position: absolute; top: 5px; right: 5px;"
											small>
											<v-icon v-if="isSelectedImage(item.id)">done</v-icon>
										</v-btn>
									</div>
								</v-layout>
							</template>
							<template v-else>
								<v-alert color="info" dense outline :value="true" align="center">
									写真が登録されていません。
								</v-alert>
							</template>
						</div>
					</div>
				</div>
				<v-layout class="selecting-menu white" align-center row outline v-if="is_selecting_images" v-bind:style="styleSelectingMenu">
					<v-btn flat block dark class="ma-0" color="#ff5252" v-on:click="onClickDeleteSelectedPreviewImages">削除</v-btn>
				</v-layout>
			</div>
		</div>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickDialogAgree"
			@disagree="onClickDialogDisagree"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import GBPhotoAlbumListAlbumHeader from './GBPhotoAlbumListAlbumHeader';
import GBPhotoAlbumSelectList from './GBPhotoAlbumSelectList';
import GBPhotoAlbumHeader from './GBPhotoAlbumHeader';
import GBPhotoAlbumDrop from './GBPhotoAlbumDrop';
import GBDialog from '../GBDialog';
import Loading from '../Loading';
import APIClient from '../../classes/APIClient';
import uuidv4 from 'uuid/v4';
import ConoHa from '../../classes/ConoHa';
import Util from '../../classes/Util'
import { IMAGE_MAX_SIZE, PHOTOALBUM_IMAGE_MAX_COUNT, GANTTBOARD_EVENT_ID } from '../../data/Const';
import VLazyImage from 'v-lazy-image';
import clonedeep from 'lodash/cloneDeep';

const strftime = require('strftime');

const HEADER_HEIGHT = 30;
const HEADER_ALBUM_HEIGHT = 59;

const chunkSplitPromiseAll = async (items, callback) => {
	let i, j, k, chunk_size = 5;

	for (i=0,j=items.length; i<j; i+=chunk_size) {
		let chunk = [];
		for (k=i; k < i + chunk_size; k++) {
			if (items[k] !== undefined)
				chunk.push(items[k]);
		}
		await Promise.all(chunk.map(callback));
	}
};

const validateLengthTitle = (value) => {
	if (value === undefined || value === null)
		return false;
	if (value.length <= 50)
		return true;

	return false;
};

const IMAGE_QUALITY = {
	DEFAULT: 0,
	HIGH_RESOLUTION: 1,
};
export default {
	name: 'GBPhotoAlbumCreate',
	props: [
	],
	data: function() {
		return {
			album: {
				title: null,
				items: []
			},
			api: new APIClient(this.$store),
			list_albums: {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			},
			photoalbum_id: null,
			project_id: null,
			member_id: null,
			schedule_id: null,
			conoha: null,
			is_selecting_images: false,
			is_camera_resolution_original: false,
			selected_images: [],
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			loading: false,
			item_quality: [{
				value: IMAGE_QUALITY.DEFAULT,
				name: "標準",
				}, {
				value: IMAGE_QUALITY.HIGH_RESOLUTION,
				name: "高画質",
			}],
			selected_quality: 0,
			items: [],
			images: [],
			RULES: {
				length_title: v => validateLengthTitle(v) || '50文字以内で入力してください',
			},
		};
	},
	components: {
		VLazyImage,
		GBPhotoAlbumListAlbumHeader,
		GBPhotoAlbumSelectList,
		GBPhotoAlbumHeader,
		GBPhotoAlbumDrop,
		Loading,
		GBDialog,
	},
	methods: {
		initData: function() {
			this.photoalbum_id = uuidv4();
			this.album = {
				title: '',
				items: []
			};
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			this.project_id = null;
			this.member_id = null;
			this.schedule_id = null;
			this.is_selecting_images = false;
			this.is_camera_resolution_original = false;
			this.selected_images = [];
			this.dialog = {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			};
			this.selected_quality = 0;
			this.items = [];
			this.images = [];
			
			this.loading = true;
			return this.getPhotoAlbumList()
				.finally(() => {
					this.loading = false;
				});
		},
		hasParent: function() {
			return this.list_albums.name !== null;
		},
		onUpdateDataSet: function() {
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			
			this.loading = true;
			this.getPhotoAlbumList()
				.finally(() => {
					this.loading = false;
				});
		},
		onPhotoUpload: function() {
			document.getElementById("select_photo").click();
		},
		onChangeFile: async function(e) {
			let files = e.target.files || e.dataTransfer.files;
			if (PHOTOALBUM_IMAGE_MAX_COUNT < this.album.items.length + files.length) {
				this.errorDialog("登録の上限を超えています。\n[" + PHOTOALBUM_IMAGE_MAX_COUNT + '枚まで]');
				return;
			}
			
			this.loading = true;
			
			let failure = [];
			let images = this.images;
			let items = this.items;
			
			let size_list = this.is_camera_resolution_original ? [
				IMAGE_MAX_SIZE.ORIGINAL,
				IMAGE_MAX_SIZE.THUMBNAIL,
			] : [ IMAGE_MAX_SIZE.SXGA,
				IMAGE_MAX_SIZE.THUMBNAIL,
			];
			let album = this.album;
			await chunkSplitPromiseAll(files, async (file) => {
				let name = file.name;
				let type = file.type;
				let item_id = uuidv4();
				let id = ['photoalbum', this.photoalbum_id, item_id].join('/');
				let item = {
					id: item_id,
					thumbnail_uri: null,
					photo_uri: null,
				};
				items.push(item);
				await Promise.all(size_list.map(size => {
					return this.conoha.generateImage(file, size)
						.then(async (res) => {
							images.push({
								'blob': res.blob,
								'src' : res.url,
								'name': size.PREFIX + name,
								'type': type,
								'size': size,
								'id': id + size.SUFFIX,
								'setURI': uploaded => {
									if (size === IMAGE_MAX_SIZE.THUMBNAIL)
										item.thumbnail_uri = uploaded.src;
									else
										item.photo_uri = uploaded.src;
								},
							});
							
							if(size === IMAGE_MAX_SIZE.THUMBNAIL)
								album.items.push({id: id + size.SUFFIX, thumbnail_uri: res.url});
						})
						.catch((e) => {
							failure.push(e);
						});
				}));
			});
			this.loading = false;
			if (failure.length > 0) {
				this.error("ファイルの読み込みに失敗しました");
				return;
			}
		},
		uploadToConoHa: async function(images) {
			let uploaded = [];
			let failure = [];
			await Util.chunkSplitPromiseAll(images, async (image) => {
				let headers = {
					'X-Object-Meta-name': encodeURIComponent(image.name),
					'Content-Disposition': 'attachment; filename=' + encodeURIComponent(image.name),
					'Content-Type': image.type,
				};
				try {
					let res = await this.conoha.upload(image.blob, headers, image.id);
					if (image.setURI)
						image.setURI(res);
					uploaded.push(res);
				} catch {
					failure.push(image.name);
				}
			});
			if (failure.length > 0) {
				throw ('upload error');
			}
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		selectPhotoAlbum: function(id) {
			let uri;
			if(this.$route.params.project_id && !this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'album'].join('/') + '/#' + id;
			else if(this.$route.params.project_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + id;
			else if(this.$route.params.member_id && this.$route.params.schedule_id)
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id, 'schedule', this.schedule_id, 'album'].join('/') + '/#' + id;
			
			this.$router.push(uri);
		},
		onClickStartSelectingImages: function() {
			this.is_selecting_images = true;
		},
		onClickImage: function(id) {
			if (this.is_selecting_images)
				return this.onClickToggleSelectImage(id);
		},
		onClickToggleSelectImage: function(id) {
			let index = this.selected_images.indexOf(id);
			if (index >= 0)
				this.selected_images.splice(index, 1);
			else
				this.selected_images.push(id);
		},
		onClickCancelSelectingImages: function() {
			this.is_selecting_images = false;
			this.selected_images = [];
		},
		onClickSelectAllImages: function() {
			this.selected_images = this.album.items.map(item => item.id);
		},
		onClickDeleteSelectedPreviewImages: async function() {
			if (this.selected_images.length === 0) {
				this.errorDialog('画像を選択してください');
				return;
			}
			for(let i = 0; i < this.selected_images.length; i ++) {
				let id = this.selected_images[i].replace(IMAGE_MAX_SIZE.THUMBNAIL.SUFFIX, '');
				for(let j = 0; j < this.images.length; j++) {
					if(this.images[j].id.indexOf(id) !== -1) {
						this.images.splice(j, 1);
						j -= 1;
					}
				}
				for(let k = 0; k < this.album.items.length; k ++) {
					if(this.album.items[k].id === this.selected_images[i]) 
						this.album.items.splice(k, 1);
				}
				
				for(let l = 0; l < this.items.length; l ++) {
					if(this.selected_images[i].indexOf(this.items[l].id) != -1) {
						this.items.splice(l, 1);
						l -= 1;
					}
				}
			}
			this.onClickCancelSelectingImages();
		},
		onClickBack: function() {
			this.$router.push(this.backURL);
		},
		onInputImageQuality: function(e) {
			if (e === IMAGE_QUALITY.DEFAULT)
				this.is_camera_resolution_original = false;
			else
				this.is_camera_resolution_original = true;
			
			this.$refs.select_quality.blur();
		},
		onClickCreateAlbum: function() {
			this.loading = true;
			if(this.isScheduleAlbum()) {
				this.createScheduleAlbum();
			} else {
				this.createProjectAlbum();
			}
		},
		createMessagePhotoAlbum: async function(talkroom_id, photoalbum_id, album) {
			let title = album.title || strftime('%Y年%m月%d日', new Date());

			return this.api.createTalkMessagePhotoAlbum(talkroom_id, photoalbum_id, title, this.items)
				.then(() => {
					this.onClickBack();
				})
				.catch((e) => {
					this.loading = false;
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		getPhotoAlbumList: async function() {
			try {
				if(this.$route.params.project_id && !this.$route.params.schedule_id) {
					this.project_id = this.$route.params.project_id;
					await this.api.getPhotoAlbumListOfProject(this.project_id)
						.then((res) => {
							this.list_albums.albums = res.data.album_list;
							this.list_albums.name = res.data.project.name;
						});
				} else if (this.$route.params.schedule_id) {
					this.schedule_id = this.$route.params.schedule_id;
					await this.api.getPhotoAlbumListOfSchedule(this.schedule_id)
						.then((res) => {
							this.list_albums.albums = res.data.album_list;
							if (this.$route.params.project_id)
								this.list_albums.name = res.data.member.name;
							else if (this.$route.params.member_id)
								this.list_albums.name = res.data.project.name;
							this.list_albums.begin = res.data.schedule.begin;
							this.list_albums.end = res.data.schedule.end;
							this.list_albums.title = res.data.schedule.title;
							this.project_id = res.data.project.id;
							this.member_id = res.data.member.id;
						});
				}
			} catch(e) {
				if (e.token) {
					this.logout();
					return;
				}
				this.selected_images = [];
				this.is_selecting_images = false;
				switch (e.response.status) {
				case 404:
					this.error('案件、もしくはスケジュールが削除されました');
					break;
				default:
					this.error('アルバムの取得に失敗しました');
				}
				throw e;
			}
		},
		onClickDialogDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickDialogAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		isScheduleAlbum: function() {
			return this.project_id && this.member_id && this.schedule_id;
		},
		createScheduleAlbum: async function() {
			let talkroom_id;
			await this.api.searchTalkRoom(this.project_id, this.member_id, this.schedule_id)
			.then(async (search_res) => {
				if (search_res.status == 200) {
					talkroom_id = search_res.data.room_id;
				} else if (search_res.status == 204) {
					await this.api.createTalkRoom(this.project_id, this.member_id, this.schedule_id)
						.then((res) => {
							talkroom_id = res.data.room_id;
						})
						.catch((e) => {
							this.loading = false;
							if (e.token) {
								this.logout();
								return;
							}
							this.error('画像のアップロードに失敗しました');
						});
				}
				this.uploadToConoHa(this.images)
					.then(async () => {
						await this.createMessagePhotoAlbum(talkroom_id, this.photoalbum_id, this.album);
						this.loading = false;
					})
					.catch(() => {
						this.loading = false;
						this.error('画像のアップロードに失敗しました');
					});
			})
			.catch((e) => {
				this.loading = false;
				if (e.token) {
					this.logout();
					return;
				}
				this.error('画像のアップロードに失敗しました');
			});
		},
		createProjectAlbum: async function() {
			this.album.title = this.album.title || strftime('%Y年%m月%d日', new Date());
			this.uploadToConoHa(this.images)
				.then(async () => {
					await this.api.createPhotoAlbum(this.photoalbum_id, this.project_id, this.items, this.album.title)
						.then(() =>{
							this.api.updateBrowseHistory(this.photoalbum_id);
							this.onClickBack();
						})
						.catch((e) => {
							this.loading = false;
							if (e.token) {
								this.logout();
								return;
							}
							switch(e.response.status) {
							case 404:
								this.list_albums = {
									name: null,
									begin: null,
									end: null,
									albums: [],
								};
								this.error('案件、もしくはスケジュールが削除されました');
								break;
							default:
								this.error('画像のアップロードに失敗しました');
								break;
							}
						});
				})
				.catch((e) => {
					this.loading = false;
					if (e.token) {
						this.logout();
						return;
					}
					this.error('画像のアップロードに失敗しました');
				});
		},
	},
	computed: {
		backURL: function() {
			let uri;
			if (this.hasParent()) {
				if (this.$route.params.project_id && !this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.project_id;
				} else if(this.$route.params.project_id && this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id].join('/') + '/#' + this.schedule_id;
				} else if(this.$route.params.member_id && this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id].join('/') + '/#' + this.schedule_id;
				}
			} else {
				if (this.$route.params.project_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
				} else if (this.$route.params.member_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
				}
			}
			return uri;
		},
		styleAlbumCliate: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - left;

			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		styleContentOuter: function() {
			let header = 90;
			return {
				height: (this.$store.getters.height - header) + 'px',
			};
		},
		stylePhotoList: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - 317;
			
			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		stylePhotoListHeight: function() {
			let height = this.$store.getters.height - HEADER_HEIGHT - HEADER_ALBUM_HEIGHT;
			if (this.is_selecting_images)
				height -= 50;
			return {height: height + 'px'};
		},
		styleSelectingMenu: function() {
			let width = this.$store.getters.width - 298;
			
			return {
				width: width + 'px'
			};
		},
		isSelectedImage: function() {
			return (id) => this.selected_images.indexOf(id) >= 0;
		},
		listItems: function() {
			return clonedeep(this.list_albums.albums).map(item => {
				return {
					'id': item.id,
					'name': item.title,
					'reference': item.reference,
				};
			});
		},
		placeholderTitle: function() {
			return strftime('%Y年%m月%d日', new Date());
		},
	},
	mounted(){
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
		
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
		
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
};
</script>
<style>
	.gb-photoalbum-create {
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}
	.gb-photoalbum-create-drag {
		position: relative;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
	}
	.gb-photoalbum-create-drag .content {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		width: 80%;
		height:50%;
		text-align: center;
		color: #FFF;
	}
	.gb-photoalbum-create .gb-album-content-outer {
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	.gb-photoalbum-create .gb-album-content-outer .content {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
		background-color: white;
	}
	.gb-photoalbum-create .gb-header-photo-list {
		position: relative;
		border:solid 1px #DFDFDF;
		height: 59px;
		border-left: none;
	}
	.gb-photoalbum-create .gb-header-photo-layout {
		position: relative;
		padding: 0px 19px 0px 0px;
		height: 57px;
	}
	.gb-photoalbum-create .gb-photo-create-list {
		background-color: white;
		border-right: 1px solid #dfdfdf;
	}
	.gb-photoalbum-create .album-name {
		font-size: x-large;
		border-bottom: solid;
	}
	.gb-photoalbum-create .btn-image-select {
		position: absolute;
		top: 3px;
		right: 0px;
	}
	.gb-photoalbum-create .selecting-menu {
		position: absolute;
		bottom: 0;
		width: 100%;
		height: 50px;
		background-color: white;
		border-top: 1px solid;
		box-shadow: -10px 10px 10px 10px rgba(0,0,0,0.4);
	}
</style>
